import { createSlice } from "@reduxjs/toolkit";

import { authApiSlice } from "../../features/auth/authApiSlice";

const slice = createSlice({
	name: "appSettings",
	initialState: { settings: null },
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			authApiSlice.endpoints.getSettingsJSON.matchFulfilled,
			(state, { payload }) => {
				state.settings = payload;
			}
		);
	},
});

export default slice.reducer;

export const selectSettings = (state) => state.appSettings.settings;
